var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M5.59998 5.59998L27.2 27.2",
          stroke: "#2B2B2B",
          "stroke-linecap": "round",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M5.59998 27.2L27.2 5.59995",
          stroke: "#2B2B2B",
          "stroke-linecap": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }